<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_mbChtDlg_styleComponentAnimation()">
		<template v-if="$_mbChtDlg_stateComponentIsInitialized">
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn	class="customVBtn"
							:color="isFalse(messageState_.chatCode) ? 'secondary' : 'primary'"
							dark
							icon
							v-on="on"
							@click="$_mbChtDlg_open()">
						<v-icon>people</v-icon>
					</v-btn>
				</template>
				<template v-if="!isFalse(messageState_.chatCode)">
					<span v-text="messageState_.chatName" />
				</template>
				<template v-else>
					Not Set
				</template>
				<v-dialog
						v-model="show_"
						max-width="600px"
						persistent>
					<v-card>
						<v-card-title>Chat</v-card-title>
						<v-card-text>
							<v-text-field
									hide-details
									outlined
									readonly
									v-model="messageState_.chatName" />
						</v-card-text>
						<v-card-actions>
							<v-row justify="center" dense>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_mbChtDlg_styleCloseButtonBlock"
											:color="$_mbChtDlg_styleCloseButtonColor"
											:dark="$_mbChtDlg_styleCloseButtonDark"
											:depressed="$_mbChtDlg_styleCloseButtonDepressed"
											:elevation="$_mbChtDlg_styleCloseButtonElevation"
											:large="$_mbChtDlg_styleCloseButtonLarge"
											:light="$_mbChtDlg_styleCloseButtonLight"
											:outlined="$_mbChtDlg_styleCloseButtonOutlined"
											:rounded="$_mbChtDlg_styleCloseButtonRounded"
											:small="$_mbChtDlg_styleCloseButtonSmall"
											:text="$_mbChtDlg_styleCloseButtonFlat"
											@click="$_mbChtDlg_close()">
										Close
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-tooltip>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'MessagebarChatDialog',
		data() {
			return {
				componentName_: 'messagebarChatDialog',

				messageState_: {},

				show_: false
			}
		},
		computed: {
			// current user
			$_mbChtDlg_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_mbChtDlg_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			$_mbChtDlg_statePageTimeline() {
				const self_ = this;
				return self_.getPageState('timeline')
			},
			$_mbChtDlg_statePageTimelineSender() {
				const self_ = this;
				const page_ = self_.$_mbChtDlg_statePageTimeline;
				return page_.sender
			},
			// contents / inits
			$_mbChtDlg_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_mbChtDlg_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_mbChtDlg_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_mbChtDlg_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_mbChtDlg_inits(), 'component')
				}
			},
			$_mbChtDlg_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_mbChtDlg_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_mbChtDlg_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_mbChtDlg_inits(), 'chip')
			},
			$_mbChtDlg_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_mbChtDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_mbChtDlg_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_mbChtDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_mbChtDlg_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_mbChtDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_mbChtDlg_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_mbChtDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_mbChtDlg_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_mbChtDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_mbChtDlg_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_mbChtDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_mbChtDlg_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_mbChtDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			$_mbChtDlg_styleCloseButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbChtDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbChtDlg_inits(), 'closeButton')
			},
			$_mbChtDlg_styleCloseButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbChtDlg_styleCloseButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbChtDlg_styleCloseButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbChtDlg_styleCloseButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbChtDlg_styleCloseButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbChtDlg_styleCloseButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbChtDlg_styleCloseButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbChtDlg_styleCloseButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbChtDlg_styleCloseButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbChtDlg_styleCloseButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbChtDlg_styleCloseButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbChtDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		beforeMount() {
			const self_ = this;

			self_.messageState_ = self_.getState('message')
		},
		methods: {
			$_mbChtDlg_open() {
				const self_ = this;
				self_.show_ = true;
			},
			$_mbChtDlg_close() {
				const self_ = this;
				self_.show_ = false;
			}
		}
	}
</script>

<style scoped>
	.row_ {
		min-height: 64px;
	}
	.overflow_ {
		max-width: 50px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
</style>
